export const SHOW_PIN_FORM = 'SHOW_PIN_FORM';
export const HIDE_PIN_FORM = 'HIDE_PIN_FORM';
